import { EnumOption } from "./enum-option"

export const CompanyStatus = {
    Active: 0,
    InActive: 1,
    MarkForDel: 2,
    AccountingHold: 3
}

export const CompanyStatusList: EnumOption[] = [
    { value: CompanyStatus.Active, label: 'Active' },
    { value: CompanyStatus.InActive, label: 'InActive' },
    { value: CompanyStatus.MarkForDel, label: 'Mark for Del' },
    { value: CompanyStatus.AccountingHold, label: 'Accounting Hold' }
]
